var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['screen-side-panel', _vm.position, { expand: !_vm.isExpand }],style:({ width: _vm.width + 'px' })},[_c('div',{staticClass:"screen-side-panel__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }